import React from 'react';

function generateStars(rating) {
    console.log('[generateStars] rating: ' + rating);
    let formattedRating = '';
    if (rating) {
        formattedRating = parseFloat(rating.toFixed(1));
    }
    let stars = '<span class="fw-semibold me-1">' + formattedRating + '</span>';

    for (let i = 1; i <= 5; i++) {
        if (i <= rating) stars += '<span class="text-warning">★</span>';
        else stars += '<span class="text-secondary">☆</span>';
    }

    return stars;
}
const ListingCard = ({ item }) => {
    const openInNewTab = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    const imgPath = item.firstMediaFileReadModel
        ? item.firstMediaFileReadModel.mediaFileImagePath
        : '/assets/images/saasapp_placeholder_more_photos_coming_soon.webp';
    const isPlaceholderImage = item.firstMediaFileReadModel ? false : true;
    const imgClass = isPlaceholderImage ? 'img-fluid mxh-20 placeholder-image' : 'img-fluid mxh-20';
    const imgAltName = item.firstMediaFileReadModel
        ? item.firstMediaFileReadModel.mediaFileName
        : 'more photos coming soon';
    let cardClassName = 'card saasapp-card saasapp-card--listing w-100 mb-3 overflow-hidden';
    const googleReviewTotalCount = item.googleReviewTotalCount ? item.googleReviewTotalCount : 0;
    const showAddress = !item.hideAddress && item.streetAddress;

    return (
        <>
            <div className="col-12 col-md-6 d-flex align-items-stretch cursor-pointer">
                <div
                    className={cardClassName}
                    onClick={() => openInNewTab('/Listings/View/' + item.idWithSlug)}
                >
                    <img src={imgPath} className={imgClass} alt={imgAltName} />
                    <div className="card-body">
                        <div className="card-text">
                            <div className="row">
                                <div className="col text-uppercase ls-2 text-truncate">
                                    {item.title}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col text-truncate text-muted fs-8">
                                    <div class="google-rating">
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: generateStars(item.googleReviewRating),
                                            }}
                                        ></span>{' '}
                                        <span class="fs-8">({googleReviewTotalCount})</span>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex flex-wrap align-items-center text-muted">
                                <i class="bi bi-ui-checks-grid me-1"></i>
                                <span class="me-1">{item.categoryName}</span>
                            </div>
                            {item.listOfTags && item.listOfTags.length > 0 && (
                                <div class="d-flex flex-wrap align-items-center text-muted">
                                    <i class="bi bi-tags me-1"></i>
                                    {item.listOfTags.map((tag, index) => (
                                        <span
                                            class="badge bg-light me-1 text-dark fw-light"
                                            key={index}
                                        >
                                            {tag}
                                        </span>
                                    ))}
                                </div>
                            )}
                            {showAddress && (
                                <div className="row">
                                    <div className="col text-truncate text-muted fs-8">
                                        {item.streetAddress}
                                    </div>
                                </div>
                            )}
                            <div className="row">
                                <div className="col">{item.cityName}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ListingCard;
